import { init } from '@rematch/core';
import user from './user';
import accounts from './accounts';
import contacts from './contacts';
import loans from './loans';
import lists from './lists';
import events from './events';
import marketing from './marketing';
import tasks from './tasks';
import reviews from './reviews';
import leadopps from './leadopps';
import gifts from './gifts';
import notes from './notes';
import gameplan from './gameplan';
import comms from './comms';
import files from './files';
import referredout from './referredout';
import offers from './offers';
import playbooks from './playbooks';
import templates from './templates';
import admin from './admin';
import messages from './messages';


const store = init( {
    models: {
        user: user,
        accounts: accounts,
        contacts: contacts,
        loans: loans,
        lists: lists,
        events: events,
        marketing: marketing,
        tasks: tasks,
        reviews: reviews,
        leadopps: leadopps,
        gifts: gifts,
        notes: notes,
        gameplan: gameplan,
        comms: comms,
        messages: messages,
        files: files,
        referredout: referredout,
        offers: offers,
        playbooks: playbooks,
        templates: templates,
        admin: admin
    }
} );

export default store;